const getRangeSize = (currentPageInput, totalPages, rangeSize) => {
  if (totalPages <= rangeSize) {
    return totalPages;
  }

  if (currentPageInput <= rangeSize || totalPages - currentPageInput < rangeSize) {
    // The 2 accounts for the ellipsis components in the paginator
    return rangeSize + 2;
  }

  return rangeSize;
};

export const buildRange = (currentPageInput, totalPages) => {
  const currentPage = currentPageInput;
  const rangeSize = getRangeSize(currentPageInput, totalPages, 4);
  const pages = [];
  const rangeWithDots = [];

  let start = 1;
  let previousPage = null;

  if (currentPage < (rangeSize / 2) + 1) {
    start = 1;
  } else if (currentPage >= (totalPages - (rangeSize / 2))) {
    start = Math.floor(totalPages - rangeSize + 1);
  } else {
    start = currentPage - Math.floor(rangeSize / 2);
  }

  for (let index = start; index <= ((start + rangeSize) - 1); index++) {
    pages.push(index);
  }

  if (!pages.includes(1)) {
    pages.unshift(1);
  }

  if (!pages.includes(totalPages)) {
    pages.push(totalPages);
  }

  for (const page of pages) {
    if (previousPage) {
      if (page - previousPage === 2) {
        rangeWithDots.push(previousPage + 1);
      } else if (page - previousPage !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(page);
    previousPage = page;
  }

  return rangeWithDots;
};
